import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import OpportunityMap from '@/components/opportunities/map_page.vue'

const loadingMarkup = `
  <div class="grid min-h-screen place-items-center bg-land-canvas px-6 text-land-ink">
    <div class="w-full max-w-md rounded-md border border-land-border bg-land-surface p-6 shadow-sm">
      <p class="text-sm font-semibold text-land-primary">Landport</p>
      <h1 class="mt-2 text-2xl font-semibold tracking-normal">Loading map</h1>
      <p class="mt-3 text-sm leading-6 text-land-ink-muted">Plotting opportunities with parcel coordinates.</p>
    </div>
  </div>
`

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    if (this.turboPreview) {
      this.showLoadingShell()
      return
    }

    this.beforeCache = () => {
      this.teardown()
      this.showLoadingShell()
    }
    document.addEventListener('turbo:before-cache', this.beforeCache)
    this.mountVue()
  }

  disconnect() {
    if (this.beforeCache) document.removeEventListener('turbo:before-cache', this.beforeCache)
    this.beforeCache = null
    this.teardown()
  }

  mountVue() {
    if (this.vue) return

    this.vue = createApp(OpportunityMap, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  teardown() {
    this.vue?.unmount()
    this.vue = null
  }

  showLoadingShell() {
    this.element.innerHTML = loadingMarkup
  }

  get turboPreview() {
    return document.documentElement.hasAttribute('data-turbo-preview')
  }
}
